const storagePrefix = "regulator:onboarding:";

export function isPristineProfile(document) {
  return ["properties", "assets", "assignments", "allocations", "policies", "browserViews"]
    .every((section) => (document?.[section] ?? []).length === 0);
}

export function hasStartedOnboarding(profileId, storage = globalThis.localStorage) {
  if (!profileId) return false;
  try {
    return storage?.getItem(`${storagePrefix}${profileId}`) === "started";
  } catch {
    return false;
  }
}

export function markOnboardingStarted(profileId, storage = globalThis.localStorage) {
  if (!profileId) return;
  try {
    storage?.setItem(`${storagePrefix}${profileId}`, "started");
  } catch {
    // Onboarding still works for the current session when local storage is unavailable.
  }
}

export function clearOnboardingProgress(profileIds, storage = globalThis.localStorage) {
  try {
    for (const profileId of profileIds) storage?.removeItem(`${storagePrefix}${profileId}`);
  } catch {
    // Resetting portfolio data must still succeed when local storage is unavailable.
  }
}
